export const PLAY_BUTTON_NEXT_EPISODE_TEXT = 'NEXT EPISODE'
export const PLAY_BUTTON_NEXT_SEASON_TEXT = 'NEXT SEASON'
export const CLOSE_BUTTON_WATCH_CREDITS_TEXT = 'WATCH CREDITS'
